import EditMailConfig from '../views/Gestion/Sitio/Mails/Edit.js';
import Links from '../views/Gestion/Sitio/Links';
import CarruselImages from '../views/Gestion/Sitio/CarruselImages';

export default {
  root: [{
    items: [
      {
        name: 'Consultador',
        url: '/consultador/articulos/',
        icon: 'fa fa-desktop',
        permission: 'consultadorarticulos_view',
      },
      {
        name: 'Ventas',
        icon: 'fa fa-book',
        items: [
          {
            name: 'Pedidos',
            icon: 'fa fa-shopping-cart',
            url: '/ventas/pedidos/',
            permission: 'ecommerce_ventas_pedidos_view',
          },
          {
            name: 'Ofertas',
            icon: 'fa fa-percent',
            url: '/ventas/ofertas/',
            permission: 'ecommerce_ventas_ofertas_view',
          },
          {
            name: 'Clientes',
            icon: 'fa fa-users',
            url: '/ventas/clientes/',
            permission: 'ecommerce_ventas_clientes_view',
          },
          {
            name: 'Vendedores',
            icon: 'fa fa-users',
            url: '/ventas/vendedores/',
            permission: 'ecommerce_ventas_vendedores_view',
          },
          {
            name: 'Condiciones de Pago',
            icon: 'fa fa-money',
            url: '/ventas/condicionesdepago/',
            permission: 'ecommerce_ventas_condicionesdepago',
          },
          {
            name: 'Tarjetas',
            icon: 'fa fa-credit-card',
            url: '/ventas/tarjetas/',
            permission: 'ecommerce_ventas_condicionesdepago',
          },
        ],
      },
      /*
      {
        name: 'Generales',
        icon: 'fa fa-list',
        items: [
          {
            name: 'Provincias',
            icon: 'fa fa-list',
            url: '/generales/provincias/',
            permission: 'ecommerce_generales_provincias',
          },
          {
            name: 'Localidades',
            icon: 'fa fa-list',
            permission: 'ecommerce_generales_localidades',
            url: '/generales/localidades/',
          },
          {
            name: 'Tipos Documento',
            icon: 'fa fa-list',
            permission: 'ecommerce_generales_tiposdocumentos',
            url: '/generales/tiposdocumentos/',
          },
          {
            name: 'Transportes',
            icon: 'fa fa-list',
            permission: 'ecommerce_generales_transportes',
            url: '/generales/transportes/',
          },
          {
            name: 'Impuestos',
            icon: 'fa fa-list',
            permission: 'ecommerce_generales_impuestos',
            url: '/generales/impuestos/',
          },
          {
            name: 'Monedas',
            icon: 'fa fa-list',
            permission: 'ecommerce_generales_monedas',
            url: '/generales/monedas/',
          },
          {
            name: 'Situación IVA',
            icon: 'fa fa-list',
            permission: 'ecommerce_generales_situacioniva',
            url: '/generales/situacioniva/',
          },
        ],
      },
      */
      {
        name: 'Artículos',
        icon: 'fa fa-cart-arrow-down',
        items: [
          {
            name: 'Artículos',
            url: '/articulos/articulos/',
            permission: 'ecommerce_articulos_articulos_view',
            icon: 'fa fa-cart-arrow-down',
          },
          {
            name: 'Destacados',
            url: '/articulos/destacados/',
            permission: 'ecommerce_articulos_destacados_view',
            icon: 'fa fa-star',
          },
          {
            name: 'Categorías',
            url: '/articulos/categorias/',
            permission: 'ecommerce_articulos_categorias_view',
            icon: 'fa fa-list',
          },
          {
            name: 'Características',
            url: '/articulos/caracteristicas/',
            permission: 'ecommerce_articulos_caracteristicas_view',
            icon: 'fa fa-list',
          },
          /*
          {
            name: 'Modelos',
            url: '/articulos/modelos/',
            permission: 'ecommerce_articulos_modelos',
            icon: 'fa fa-list',
          },
          {
            name: 'Proveedores',
            url: '/articulos/proveedores/',
            permission: 'ecommerce_articulos_proveedores',
            icon: 'fa fa-list',
          },
          */
          {
            name: 'Talles',
            url: '/articulos/talles/',
            permission: 'ecommerce_articulos_talles',
            icon: 'fa fa-list',
          },
          {
            name: 'Colores',
            url: '/articulos/colores/',
            permission: 'ecommerce_articulos_colores',
            icon: 'fa fa-list',
          },
          {
            name: 'Grupos',
            url: '/articulos/grupos/',
            permission: 'ecommerce_articulos_grupos',
            icon: 'fa fa-list',
          },
          /*
          {
            name: 'Marcas',
            url: '/articulos/marcas/',
            permission: 'ecommerce_articulos_marcas',
            icon: 'fa fa-list',
          },
          {
            name: 'Materiales',
            url: '/articulos/materiales/',
            permission: 'ecommerce_articulos_materiales',
            icon: 'fa fa-list',
          },
          */
         {
           name: 'Rubros',
           url: '/articulos/rubros/',
           permission: 'ecommerce_articulos_rubros',
           icon: 'fa fa-list',
          },
          {
            name: 'Lineas',
            url: '/articulos/lineas/',
            permission: 'ecommerce_articulos_lineas',
            icon: 'fa fa-list',
          },
          /*

          {
            name: 'Unidades de Medida',
            url: '/articulos/unidadesmedida/',
            permission: 'ecommerce_articulos_unidadesdemedida',
            icon: 'fa fa-list',
          },
          */
        ]
      },
      /*
      {
        name: 'Stock',
        icon: 'fa fa-square',
        items: [
          {
            name: 'Stock',
            icon: 'fa fa-square',
            permission: 'ecommerce_stock_movimientos',
            url: '/stock/stock/',
          },
          {
            name: 'Sucursales',
            icon: 'fa fa-list',
            permission: 'ecommerce_stock_sucursales',
            url: '/stock/sucursales/',
          },
          {
            name: 'Depositos',
            icon: 'fa fa-list',
            permission: 'ecommerce_stock_depositos',
            url: '/stock/depositos/',
          },
        ],
      },
      */
      {
        name: 'Precios',
        icon: 'fa fa-usd',
        items: [
          {
            name: 'Precios',
            icon: 'fa fa-money',
            permission: 'ecommerce_precios_precios',
            url: '/precios/precios/',
          },
          {
            name: 'Listas',
            icon: 'fa fa-list',
            permission: 'ecommerce_precios_precios',
            url: '/precios/listas/',
          },
          {
            name: 'Asignar',
            icon: 'fa fa-list',
            permission: 'ecommerce_precios_precios',
            url: '/precios/asignar/',
          },
        ],
      },
      {
        name: 'Movimientos Cta. Cte.',
        icon: 'fa fa-list',
        permission: 'ecommerce_movcc',
        url: '/cuentascorrientes/movimientos/'
      },
      {
        name: 'Sitio',
        icon: 'fa fa-home',
        items: [
          {
            name: 'Configuración',
            icon: 'fa fa-cog',
            permission: 'ecommerce_config_config',
            url: '/sitio/configuracion/',
          },
          {
            name: 'Links',
            icon: 'fa fa-link',
            permission: 'ecommerce_config_menu',
            component: Links,
          },
          {
            name: 'Imagenes de Carrusel',
            icon: 'fa fa-picture-o',
            permission: 'ecommerce_config_menu',
            component: CarruselImages,
          },
          {
            name: 'Novedades',
            permission: 'ecommerce_config_novedades_view',
            icon: 'fa fa-newspaper-o',
            url: '/sitio/novedades/',
          },
          {
            name: 'Mails',
            icon: 'fa fa-envelope-o',
            items: [
              {
                name: 'Configuración',
                className: 'nav-link',
                component: EditMailConfig,
                permission: 'ecommerce_config_email'
              },
              {
                name: 'Casillas',
                url: '/sitio/mails/casillas/',
                permission: 'ecommerce_config_email'
              },
              {
                name: 'Plantillas',
                url: '/sitio/mails/plantillas/',
                permission: 'ecommerce_config_email'
              },
            ]
          },
          {
            name: 'Bitacora',
            icon: 'fa fa-book',
            permission: 'ecommerce_config_config',
            url: '/sitio/bitacora/',
          },
        ]
      },
      {
        name: 'Usuarios',
        icon: 'icon-user',
        items: [
          {
            name: 'Usuarios',
            url: '/usuarios/usuarios/',
            icon: 'fa fa-user',
            permission: 'usuarios_usuarios_view'
          },
          {
            name: 'Permisos',
            url: '/usuarios/permisos/',
            icon: 'fa fa-lock',
            permission: 'superadmin'
          },
          {
            name: 'Grupos',
            url: '/usuarios/grupos/',
            icon: 'fa fa-users',
            permission: 'superadmin',
          },
        ]
      },
      {
        name: 'Otros',
        icon: 'fa fa-list',
        permission: 'usuarios_usuarios_view',
      },
      {
        name: 'Ayuda',
        url: '/ayuda/',
        icon: 'fa fa-question-circle',
        permission: 'usuarios_usuarios_view'
      },
      {
        name: 'Empresas',
        icon: 'fa fa-building',
        permission: 'empresas_view',
        url: '/gestion/empresas/',
      },
    ]
  }]
};



// WEBPACK FOOTER //
// ./src/components/Menues.js